

















import './KisweCheckbox.scss'
import { defineComponent } from '@vue/composition-api'
import { generateRandomString } from '@/modules/common/utils'
import { useSizes } from '../../compositions'
import { KisweSize } from '../../types'
import { KisweButton } from '../KisweButton'
import KisweIcon from '../KisweIcon'

export default defineComponent({
  name: 'KisweCheckbox',
  components: {
    KisweButton,
    KisweIcon
  },
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Boolean,
      required: true
    },
    placeholder: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    ...useSizes({ size: KisweSize.Mini }).props
  },
  data: () => ({
    id: `kiswe-checkbox--${ generateRandomString(12, false) }`
  }),
  computed: {
    val: {
      get (): boolean {
        return this.value
      },
      set (newVal: boolean) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    toggle () {
      this.val = !this.val
    }
  }
})
